export const SPACING = {
  "Space.2": {
    defaultValue: "2px"
  },
  "Space.4": {
    defaultValue: "4px"
  },
  "Space.6": {
    defaultValue: "6px"
  },
  "Space.8": {
    defaultValue: "8px"
  },
  "Space.10": {
    defaultValue: "10px"
  },
  "Space.12": {
    defaultValue: "12px"
  },
  "Space.16": {
    defaultValue: "16px"
  },
  "Space.18": {
    defaultValue: "18px"
  },
  "Space.20": {
    defaultValue: "20px"
  },
  "Space.24": {
    defaultValue: "24px"
  },
  "Space.28": {
    defaultValue: "28px"
  },
  "Space.32": {
    defaultValue: "32px"
  },
  "Space.36": {
    defaultValue: "36px"
  },
  "Space.40": {
    defaultValue: "40px"
  },
  "Space.48": {
    defaultValue: "48px"
  },
  "Space.60": {
    defaultValue: "60px"
  },
  "Space.72": {
    defaultValue: "72px"
  }
};
